export const AbrMode = {
  MANUAL: 'manual',
  AUTO: 'auto'
} as const;
